import React, { Component } from 'react';
import { Modal, Button, Spin } from 'antd';
import TableC from '../../../basicElement/TableC';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';

class ProcessDetailModal extends Component {
    state = {
        loading: false,
        visible: false,
        fteList: [],
        assignments: [],
        requirementCode: '',
    }

    show = id => {
        this.setState({
            visible: true,
            fteList: [],
            assignments: [],
            requirementCode: '',
        }, () => {
            id && this.loadData(id);
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    loadData = requirementId => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.member.queryFteAssignDetail,
            data: { requirementId },
            doneResult: res => {
                const { fteList, assignments, requirementCode } = res.data;
                this.setState({
                    fteList,
                    assignments,
                    requirementCode,
                    loading: false,
                });
            },
        };
        $.sendRequest(options);
    }

    getColumns = () => {
        const { fteList } = this.state;

        const columns = [{
            title: '工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            fixed: 'left',
            width: 100,
        }, {
            title: '姓名',
            dataIndex: 'employeeName',
            key: 'employeeName',
            fixed: 'left',
            width: 100,
        }];

        (fteList || []).forEach(fte => {
            const time = `${fte.year}.${fte.month}`;
            columns.push({
                title: time,
                children: [{
                    title: '已分配',
                    dataIndex: `${time}_fte`,
                    key: `${time}_fte`,
                    width: 60,
                }, {
                    title: '预分配',
                    dataIndex: `${time}_pfte`,
                    key: `${time}_pfte`,
                    width: 60,
                }],
            });
        });
        
        return columns;
    }

    getDataSource = () => {
        const { assignments } = this.state;
        const resource = (assignments || []).map(item => {
            const { userName, employeeCode, detailList } = item;
            const params = {
                employeeName: userName,
                employeeCode,
            };
            (detailList || []).forEach(i => {
                const time = `${i.year}.${i.month}`;
                params[`${time}_fte`] = i.planFte;
                params[`${time}_pfte`] = i.prospectiveFte;
            });
            return params;
        });
        return resource;
    }

    render() {
        const { loading, visible, requirementCode } = this.state;
        return (
            <Modal
                title='需求分配明细'
                visible={visible}
                onCancel={this.hide}
                width="1000px"
                maskClosable={false}
                bodyStyle={{ maxHeight: 500 }}
                footer={<Button type="ghost" onClick={this.hide}>关闭</Button>}
            >
                <Spin spinning={loading}>
                    <div style={{ marginBottom: 10 }}>需求编号：{requirementCode}</div>
                    <TableC
                        columns={this.getColumns()}
                        data={this.getDataSource()}
                        rowKey="id"
                        pagination={false}
                        scrollY={380}
                        className="processDetail"
                    />
                </Spin>
            </Modal>
        );
    }
}

export default ProcessDetailModal;



// WEBPACK FOOTER //
// ./src/components/user/require/components/ProcessDetail.js